export default {
  primaryDefault: '#78BE20',
  primaryDefault02: '#78BE2055',
  primaryPressed: '#679E18',
  darkGreen: '#397615',
  lightGreen: '#D4EB8E',
  whiteGreen: '#F1F8EC',
  yellowGreen: '#CEDC00',

  black: '#000',
  textDefault: '#333',
  darkGray: '#666',
  gray: '#A6A6A6',
  lightGray: '#E5E5E5',
  whiteGray: '#F8F8F8',
  white: '#FFF',

  red: '#ED1C24',
  pink: '#F2DCDD',
  yellow: '#FAE800',
  lightYellow: '#FFFCCF',

  textYellow: '#F6D835',
  purple: '#AC488C',

  darkGray02: 'rgba(102, 102, 102, 0.2)',
  darkGray04: 'rgba(102, 102, 102, 0.4)',
  shadowHover: 'rgba(0, 0, 0, 0.3)'
}
